import { useState } from 'react'
import { Pagination } from 'shared/types'

export const usePagination = (
  initialSize = 5,
  totalRowsCount = 0
): Pagination => {
  const [page, setPage] = useState(1)
  const [currentPageSize, setCurrentPageSize] = useState(initialSize)

  const setPageSize = (size: number) => {
    setCurrentPageSize(size)
    setPage(1)
  }

  return {
    setPageSize,
    pageSize: currentPageSize,
    page,
    setPage,
    totalRowsCount,
  }
}
